<template>
  <div :style="getStyle" class="container fontIcon-container">
    <cxIcon v-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
    <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cxIconCom",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      update: false
    }
  },
  mounted() {},
  computed: {
    ids() {
      return this.myid
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    iconSrc() {
      // if(!this.options){
      //   return ""
      // }
      // if(!this.options.hasOwnProperty("iconSrcType")){
      //   return this.options.iconSrc
      // }
      let iconSrc
      let iconSrcType = Number(this.options.iconSrcType)
      console.log('iconSrcType',iconSrcType)
      switch (iconSrcType){
        case 0:
          iconSrc = this.options.iconSrc
          break
        case 1:
          iconSrc = this.options.hoverIconSrc
          break
        case 2:
          iconSrc = this.options.clickIconSrc
          break
        default:
          iconSrc = this.options.iconSrc
      }
      return iconSrc
    },
    iconType() {
      return this.options ? this.options.iconType : "icon"
    },
    getStyle() {
      let height = this.options.heightType === "%" ? "100%" : this.options.height + "px"
      return {
        opacity: this.options.opacity,
        "box-shadow": this.boxShadowStyle,
        height: height,
        ...this.bgStyle
      }
    },
    getIconStyle() {
      return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        // "--color": this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor,
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: "100%",
        height: "100%",
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getIconImgStyle() {
      return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        // width: this.options.iconWidth + "px",
        width: "100%",
        height: "100%",
      }
    }
  },
  watch: {
    // iconSrc: {
    //   immediate: true,
    //   handler: function (n, o) {
    //     if (!!n && this.iconType === "icon") {
    //       this.update = true
    //       let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    //       this.instance.get(contextPath + `v2/svg/${n}`).then(res => {
    //         if (res.status === 200) {
    //           this.iconContent = res.data
    //           this.update = false
    //           this.$forceUpdate()
    //         }
    //       })
    //     }
    //   }
    // }
  },
  methods: {}
}
</script>

<style scoped>
.container {
  text-align: center;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
